"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-appsettings"
  }, [_c('div', {
    staticClass: "app-appsettings-close",
    on: {
      "click": _vm.closeSettings
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('close')))]), _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('form', {
    staticClass: "u-form"
  }, [_c('tabbed-view', {
    ref: "tabs",
    staticClass: "app-appsettings-tab-container"
  }, [_c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings_general'),
      "focus": true,
      "name": "general"
    }
  }, [_c('div', {
    staticClass: "app-appsettings-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_general')))]), _c('div', {
    staticClass: "app-appsettings-section app-appsettings-general"
  }, [_c('label', {
    staticClass: "app-appsettings-setting-language"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_language')))]), _c('div', [_c('i', {
    staticClass: "fa fa-globe"
  })]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingLanguage,
      expression: "settingLanguage"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.settingLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" Auto ")]), _vm._l(_vm.localesList, function (l) {
    return _c('option', {
      key: l[0],
      domProps: {
        "value": l[0]
      }
    }, [_vm._v(" " + _vm._s(l[1]) + " ")]);
  })], 2)]), _c('label', {
    staticClass: "app-appsettings-setting-theme"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_theme')) + " ")]), _c('a', {
    staticClass: "app-appsettings-theme-reload",
    attrs: {
      "title": _vm.$t('refresh_theme')
    },
    on: {
      "click": _vm.refreshTheme
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.theme,
      expression: "theme"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.theme = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.settings.themes, function (t) {
    return _c('option', {
      key: t.name,
      domProps: {
        "value": t.name
      }
    }, [_vm._v(" " + _vm._s(t.name) + " ")]);
  }), 0)]), _vm.theme.toLowerCase() === 'custom' ? _c('label', {
    staticClass: "app-appsettings-setting-theme-custom"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_themeurl')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customThemeUrl,
      expression: "customThemeUrl"
    }],
    staticClass: "u-input",
    domProps: {
      "value": _vm.customThemeUrl
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.customThemeUrl = $event.target.value;
      }
    }
  })]) : _vm._e(), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_autocomplete')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingShowAutoComplete,
      expression: "settingShowAutoComplete"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowAutoComplete) ? _vm._i(_vm.settingShowAutoComplete, null) > -1 : _vm.settingShowAutoComplete
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingShowAutoComplete,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowAutoComplete = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingShowAutoComplete = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingShowAutoComplete = $$c;
        }
      }
    }
  })]), _vm.themeSupportsMonospace ? _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_use_monospace')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingUseMonospace,
      expression: "settingUseMonospace"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingUseMonospace) ? _vm._i(_vm.settingUseMonospace, null) > -1 : _vm.settingUseMonospace
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingUseMonospace,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingUseMonospace = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingUseMonospace = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingUseMonospace = $$c;
        }
      }
    }
  })]) : _vm._e(), _vm.canRegisterProtocolHandler ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": function ($event) {
        return _vm.makeDefaultProtocolHandler();
      }
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('settings_default_handler')))])])]) : _vm._e()])]), _c('div', {
    staticClass: "app-appsettings-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_messages_title')))]), _c('div', {
    staticClass: "app-appsettings-section app-appsettings-messages"
  }, [_c('label', {
    staticClass: "app-appsettings-messagelistDisplay"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_messagelayout')) + " ")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingMessageLayout,
      expression: "settingMessageLayout"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.settingMessageLayout = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "traditional"
    }
  }, [_vm._v("Traditional")]), _c('option', {
    attrs: {
      "value": "modern"
    }
  }, [_vm._v("Modern")]), _c('option', {
    attrs: {
      "value": "inline"
    }
  }, [_vm._v("Inline")])])]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_timestamps')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferShowTimestamps,
      expression: "settingBufferShowTimestamps"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShowTimestamps) ? _vm._i(_vm.settingBufferShowTimestamps, null) > -1 : _vm.settingBufferShowTimestamps
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferShowTimestamps,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShowTimestamps = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferShowTimestamps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferShowTimestamps = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_24hour_timestamps')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.timestamps_24h,
      expression: "timestamps_24h"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.timestamps_24h) ? _vm._i(_vm.timestamps_24h, null) > -1 : _vm.timestamps_24h
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.timestamps_24h,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.timestamps_24h = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.timestamps_24h = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.timestamps_24h = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_emoticons')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferShowEmoticons,
      expression: "settingBufferShowEmoticons"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShowEmoticons) ? _vm._i(_vm.settingBufferShowEmoticons, null) > -1 : _vm.settingBufferShowEmoticons
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferShowEmoticons,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShowEmoticons = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferShowEmoticons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferShowEmoticons = $$c;
        }
      }
    }
  })]), false ? [_c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v("Afficher les couleurs IRC ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferShowMessageColors,
      expression: "settingBufferShowMessageColors"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShowMessageColors) ? _vm._i(_vm.settingBufferShowMessageColors, null) > -1 : _vm.settingBufferShowMessageColors
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferShowMessageColors,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShowMessageColors = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferShowMessageColors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferShowMessageColors = $$c;
        }
      }
    }
  })])] : _vm._e(), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v("Afficher les éjections et bannissements ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferShowKicks,
      expression: "settingBufferShowKicks"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShowKicks) ? _vm._i(_vm.settingBufferShowKicks, null) > -1 : _vm.settingBufferShowKicks
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferShowKicks,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShowKicks = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferShowKicks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferShowKicks = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_block_private')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferBlockPms,
      expression: "settingBufferBlockPms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferBlockPms) ? _vm._i(_vm.settingBufferBlockPms, null) > -1 : _vm.settingBufferBlockPms
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferBlockPms,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferBlockPms = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferBlockPms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferBlockPms = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "app-appsettings-full app-appsettings-setting-scrollback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferScrollbackSize,
      expression: "settingBufferScrollbackSize"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.settingBufferScrollbackSize
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.settingBufferScrollbackSize = $event.target.value;
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('settings_scrollback')) + " ")])]), false ? [_c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_formatting')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferExtraFormatting,
      expression: "settingBufferExtraFormatting"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferExtraFormatting) ? _vm._i(_vm.settingBufferExtraFormatting, null) > -1 : _vm.settingBufferExtraFormatting
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferExtraFormatting,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferExtraFormatting = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferExtraFormatting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferExtraFormatting = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_nick_colouring')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferColourNicknames,
      expression: "settingBufferColourNicknames"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferColourNicknames) ? _vm._i(_vm.settingBufferColourNicknames, null) > -1 : _vm.settingBufferColourNicknames
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferColourNicknames,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferColourNicknames = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferColourNicknames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferColourNicknames = $$c;
        }
      }
    }
  })])] : _vm._e(), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_share_typing')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferShareTyping,
      expression: "settingBufferShareTyping"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferShareTyping) ? _vm._i(_vm.settingBufferShareTyping, null) > -1 : _vm.settingBufferShareTyping
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferShareTyping,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferShareTyping = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferShareTyping = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferShareTyping = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_inline_previews')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferInlineLinkPreviews,
      expression: "settingBufferInlineLinkPreviews"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferInlineLinkPreviews) ? _vm._i(_vm.settingBufferInlineLinkPreviews, null) > -1 : _vm.settingBufferInlineLinkPreviews
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferInlineLinkPreviews,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferInlineLinkPreviews = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferInlineLinkPreviews = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferInlineLinkPreviews = $$c;
        }
      }
    }
  })])], 2)]), _c('div', {
    staticClass: "app-appsettings-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('notifications')))]), _c('div', {
    staticClass: "app-appsettings-section app-appsettings-notifications"
  }, [_c('label', {
    staticClass: "app-appsettings-setting-showjoinpart u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_joinpart')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferTrafficAsActivity,
      expression: "settingBufferTrafficAsActivity"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferTrafficAsActivity) ? _vm._i(_vm.settingBufferTrafficAsActivity, null) > -1 : _vm.settingBufferTrafficAsActivity
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferTrafficAsActivity,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferTrafficAsActivity = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferTrafficAsActivity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferTrafficAsActivity = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_mute_sound')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingBufferMuteSound,
      expression: "settingBufferMuteSound"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingBufferMuteSound) ? _vm._i(_vm.settingBufferMuteSound, null) > -1 : _vm.settingBufferMuteSound
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settingBufferMuteSound,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingBufferMuteSound = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.settingBufferMuteSound = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.settingBufferMuteSound = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "app-appsettings-full"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_highlight')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingHighlights,
      expression: "settingHighlights"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.settingHighlights
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.settingHighlights = $event.target.value;
      }
    }
  })])])]), _c('div', {
    staticClass: "app-appsettings-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('operator_tools')))]), _c('div', {
    staticClass: "app-appsettings-section app-appsettings-operator-tools"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_default_ban_mask')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingDefaultBanMask,
      expression: "settingDefaultBanMask"
    }],
    staticClass: "u-input",
    domProps: {
      "value": _vm.settingDefaultBanMask
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.settingDefaultBanMask = $event.target.value;
      }
    }
  })]), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_default_kick_reason')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settingDefaultKickReason,
      expression: "settingDefaultKickReason"
    }],
    staticClass: "u-input",
    domProps: {
      "value": _vm.settingDefaultKickReason
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.settingDefaultKickReason = $event.target.value;
      }
    }
  })])])]), !_vm.$state.setting('hide_advanced') && !_vm.settingAdvancedEnable ? _c('div', {
    staticClass: "app-appsettings-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_advanced_title')))]), _c('div', {
    staticClass: "app-appsettings-section app-appsettings-advanced-enable"
  }, [_c('div', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('warning')) + " ")]), _vm._v(" " + _vm._s(_vm.$t('settings_advanced_warning')) + " ")]), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "u-button u-button-warning",
    on: {
      "click": function ($event) {
        return _vm.enableAdvancedTab();
      }
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('settings_advanced_button')))])])])])]) : _vm._e()]), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings_aliases'),
      "name": "aliases"
    }
  }, [_c('div', {
    staticClass: "app-appsettings-block app-appsettings-block-aliases"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_aliases')))]), _c('div', {
    staticClass: "app-appsettings-section app-appsettings-aliases"
  }, [_c('settings-aliases')], 1)])]), _vm.settingAdvancedEnable ? _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings_advanced'),
      "name": "advanced"
    }
  }, [_c('div', {
    staticClass: "app-appsettings-block app-appsettings-block-advanced"
  }, [_c('div', {
    staticClass: "app-appsettings-section app-appsettings-advanced"
  }, [_c('settings-advanced')], 1)])]) : _vm._e(), _vm._l(_vm.pluginUiElements, function (item) {
    return _c('tabbed-tab', {
      key: item.id,
      attrs: {
        "header": item.title(),
        "name": item.tabName
      }
    }, [_c(item.component, _vm._b({
      tag: "component"
    }, 'component', item.props, false))], 1);
  })], 2)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];